import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const productOptionPresetsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'productOptionPresets'] as const;

  return createQueryKey({
    all: key,
    id: (itemId: QueryKeyParam) =>
      createQueryKey({
        all: [...key, itemId] as const,
        detail: [...key, itemId, 'detail'] as const,
      }),
  });
};

export { productOptionPresetsKeys };
